// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/Downloads/website-with-next-js/node_modules/next/dist/esm/client/components/render-from-template-context.js <module evaluation>"));
